<template>
    <div class="st-main-content">
        <div class="detailBox">
            <div class="detailTop">
                <div class="detailTopLine clearfix">
                    
                    <div class="itemTopFl"><span>订单号：</span>{{orderDetail.waybillNo || ''}}</div>
                    <div class="itemTopFl"><span>下单时间：</span>{{ formatDate(orderDetail.createTime) || ''}}</div>
                    <div class="itemTopFl"><span>预约提货时间：</span>{{  formatDate(orderDetail.pickupTime)|| ''}}</div>
                 <!--   <div class="itemTopFl"><span>订单类型：</span>{{orderDetail.createFromDesc || ''}}</div> -->
                    <div class="itemTopFl"><span>最新状态：</span>{{orderDetail.stateDesc || ''}}</div>
                </div>
                <div class="topTable">
                    <table class="stTableOne">
                        <!-- <tr>
                            <td class="titleBg">下单人</td>
                            <td>{{orderDetail.ownerName || ''}}</td>
                            <td  class="titleBg">电话</td>
                            <td>{{orderDetail.ownerPhone || ''}}</td>
                        </tr> -->
                        <tr>
                            <td class="titleBg">发货人</td>
                            <td>{{orderDetail.waybillConsignAddresses[0].contactSubject || ''}}</td>
                            <td class="titleBg">收货人</td>
                            <td>{{orderDetail.waybillReceiveAddresses[0].contactSubject || ''}}</td>
                        </tr>
                        <tr>
                            <td class="titleBg">发货人手机</td>
                            <td>{{orderDetail.waybillConsignAddresses[0].contactPhone || ''}}</td>
                            <td class="titleBg">收货人手机</td>
                            <td>{{orderDetail.waybillReceiveAddresses[0].contactPhone || ''}}</td>
                        </tr>
                        <tr>
                            <td class="titleBg">发货人地址</td>
                            <td>{{orderDetail.waybillConsignAddresses[0].shortAddress || ''}}</td>
                            <td class="titleBg">收货人地址</td>
                            <td>{{orderDetail.waybillReceiveAddresses[0].shortAddress || ''}}</td>
                        </tr>
                    </table>
                   <!-- <table class="stTableTwo">
                        <tr> 
                            <td rowspan=2  class="titleBg">订单公里数</td>
                            <td rowspan=2>{{orderDetail.wholeDistance || ''}}</td>
                            <td class="titleBg">货主起步公里数</td>
                            <td>{{orderDetail.cost && orderDetail.cost.ownerStartKilometer}}</td>
                            <td class="titleBg">货主起步价</td>
                            <td>{{orderDetail.cost && orderDetail.cost.ownerStartFee}}</td>
                            
                            <td class="titleBg">司机使用优惠券金额</td>
                            <td>{{orderDetail.stcouponDetail && orderDetail.stcouponDetail.driverCouponFee}}</td>
                            <td class="titleBg">订单金额</td>
                            <td>{{orderDetail.cost && orderDetail.cost.ownerExpressFee}}</td>
                        </tr>
                        <tr> 
                            <td class="titleBg">超公里数</td>
                            <td>{{orderDetail.cost && orderDetail.cost.overKilometer || ''}}</td>
                            <td class="titleBg">超公里价</td>
                            <td>{{orderDetail.cost && orderDetail.cost.ownerPerKilometerFee}}</td>
                            
                            <td class="titleBg">货主使用优惠券金额</td>
                            <td>{{orderDetail.stcouponDetail && orderDetail.stcouponDetail.ownerCouponFee}}</td>
                            <td class="titleBg">实付金额</td>
                            <td>{{orderDetail.payFee}}</td>
                        </tr>
                    </table> -->
                </div>
            </div>
            <div class="detailBottom" v-if="orderDetail.state ===3||orderDetail.state ===4||orderDetail.state ===5">
                <div class="detailTopLine clearfix">
                    <div class="itemTopFl"><span>车牌号：</span>{{orderDetail.carNo || ''}}</div>
                    <div class="itemTopFl"><span>车型：</span>{{orderDetail.cost && orderDetail.cost.vehicleModel || ''}}</div>
                    <div class="itemTopFl"><span>司机姓名：</span>{{orderDetail.driverName || ''}}</div>
                    <div class="itemTopFl"><span>司机手机：</span>{{orderDetail.driverPhone}}</div>
                </div>
                <div>
                    <table>
                        <tr class="titleBg">    
                            <td>状态</td>
                            <td>状态变化时间 </td>
                            <td>经纬度</td>
                            <td>详细地址</td>
                        </tr>
                        <tr v-for="item in orderDetail.location" >    
                            <td>{{item.stateDesc}}</td>
                            <td>{{item.createTime}} </td>
                            <td>{{item.latitude}},{{item.longitude}}</td>
                            <td>{{item.addressDetail}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'OrderDetail',
    data(){
        return{
            orderDetail:{}
        }
    },
    mounted(){
       let  waybillNo=this.$route.params.waybillNo
        if(waybillNo){
            console.log(waybillNo)
            this.getDetail(waybillNo)
        }
    },
    methods:{
        getDetail(waybillNo){
            this.$server.business.logiswaybillDetail(waybillNo, res=>{
                this.orderDetail=res.data;
            }) 
        },
		 formatDate(value) {
		        let date = new Date(value);
		        let y = date.getFullYear();
		        let MM = date.getMonth() + 1;
		        MM = MM < 10 ? "0" + MM : MM;
		        let d = date.getDate();
		        d = d < 10 ? "0" + d : d;
		        let h = date.getHours();
		        h = h < 10 ? "0" + h : h;
		        let m = date.getMinutes();
		        m = m < 10 ? "0" + m : m;
		        let s = date.getSeconds();
		        s = s < 10 ? "0" + s : s;
		        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
		      }
    }
    

}
</script>
<style scoped>
    .detailBox{
        padding: 0 20px;
        background:#fff;
        height: 100%;
    }
    .detailTop{
        background:#fff;
    }
    .detailTopLine{
        padding: 15px;
    }
    .itemTopFl{
        float: left;
        margin-right: 15px;
    }
    .detailBottom{
        background:#fff;
        padding-bottom: 20px;
    }
    .topTable{

    }
    table{
        width: 100%;
    }
    th{width: 100%;}
    td{
        min-width: 100px;
        height: 30px;
        line-height: 30px;
        padding-left: 8px;
        border: 1px solid #ccc;
        box-sizing: border-box;
        vertical-align: middle;
    }
    .stTableTwo{
        margin: 20px 0;
    }
    .titleBg{
        background: #ff8570;
        color: #fff;
    }
    .itemTopFl span{
        color: #FF5B3E;
    }
   
    
</style>